import { render, staticRenderFns } from "./ChangePasswordModalComponent.vue?vue&type=template&id=51980f39&scoped=true&"
import script from "./ChangePasswordModalComponent.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51980f39",
  null
  
)

export default component.exports